import { Ref } from 'react';
import {
  DeviceLocation,
} from '../types';
// eslint-disable-next-line import/no-cycle
import { getQueueConfig, IAdLoop, QueueConfig } from '../views/AdLoop/requests';

export const getCoordinates = (): Promise<GeolocationPosition> => new Promise((resolve, reject) => {
  navigator.geolocation.getCurrentPosition(resolve, reject, {
    enableHighAccuracy: true,
    timeout: 2000,
  });
});

export const getLocation = async (): Promise<DeviceLocation> => {
  try {
    const position = await getCoordinates();
    const { coords } = position;
    const { latitude, longitude } = coords;
    return { lat: latitude, lng: longitude };
  } catch (error) {
    return { error };
  }
};

export const cleanCurrentAd = (ad: IAdLoop, queue: IAdLoop[]): IAdLoop[] => {
  if (ad?.mediaFile?.blobURL) {
    URL.revokeObjectURL(ad.mediaFile.blobURL);
  }
  return queue?.filter((currAd) => currAd.uniqueId !== ad.uniqueId);
};

type GroupedObject<T> = {
  [key: string]: T[];
};

export const groupBy = <T>(arr: T[], key: string): GroupedObject<T> => arr.reduce((acc, currentItem) => {
  const itemKey: string = (currentItem as any)[key];

  if (!acc[itemKey]) {
    acc[itemKey] = [];
  }

  acc[itemKey].push(currentItem);

  return acc;
}, {} as GroupedObject<T>);

// export const downloadMedia = async (mediaUrl: string): Promise<string> => {
//   if (mediaUrl) {
//     try {
//       const { data } = await axios.get(`${streetsUrl}/media`, {
//         params: { url: mediaUrl },
//         responseType: 'blob',
//       });
//       return URL.createObjectURL(data);
//     } catch (err) {
//       console.error(err);
//     }
//   }
//
//   return '';
// };

export const getNth = (n: number): string => (n > 3 && n < 21 ? 'th' : n % 10 === 1 ? 'st' : n % 10 === 2 ? 'nd' : n % 10 === 3 ? 'rd' : 'th');

export const parseConfig = async (config: Ref<QueueConfig>): Promise<unknown> => {
  const configResponse = await getQueueConfig();
  if ('error' in configResponse) return;
  configResponse.weights = getSimplifiedQueueWeights(configResponse.weights);

  // @ts-ignore
  config.current = configResponse;
};

export function getSimplifiedQueueWeights<T>(weights: T): T {
  const findGCD = () => {
    const arr = Object.values(weights);
    const gcd = (a: number, b: number): number => {
      if (a === 0) return b;
      return gcd(b % a, a);
    };

    let result = arr[0];
    const n = arr.length;
    for (let i = 1; i < n; i += 1) {
      result = gcd(arr[i], result);

      if (result === 1) {
        return 1;
      }
    }
    return result;
  };

  const gcd = findGCD();

  const simplifiedWeights = {} as T;
  Object.keys(weights).forEach((key) => {
    // @ts-ignore
    simplifiedWeights[key] = weights[key] / gcd;
  });

  return simplifiedWeights;
}

export const LOCATION_LOGIN_NOTIFICATION_WAIT_TIME = 60 * 1000;
export const NotificationType = {
  Location: 'location',
  Login: 'login',
  QueueCap: 'queueCap',
};
